import type { Country, Language } from "@commerce-shared/site-config";
import { getStaticUrl, replaceParams } from "@commerce-shared/url";
import type { FragmentOf } from "gql.tada";
import { getTranslations } from "next-intl/server";
import type { AccountMenuItem } from "~/app/[language]/(regular-layout)/account/_components/layout/types";
import type {
	CardProductFragment,
	CardProductVariantFragment,
} from "~/components/product/ProductCard/ProductCard.fragments";

export const buildAccountMenu = async (
	country: Country,
	language: Language,
	isWishlistEnabled: boolean,
): Promise<AccountMenuItem[]> => {
	const t = await getTranslations("AccountLayout");

	const accountMenu = [
		{
			href: getStaticUrl("account", language, country),
			icon: "dashboard",
			label: t("overview"),
		},
		{
			href: getStaticUrl("account/orders", language, country),
			icon: "box-outline",
			label: t("orders"),
		},
		{
			href: getStaticUrl("account/profile", language, country),
			icon: "user",
			label: t("profile"),
		},
		{
			href: getStaticUrl("account/wishlist", language, country),
			icon: "heart-outline",
			label: t("favorites"),
		},
	] as AccountMenuItem[];

	return isWishlistEnabled
		? accountMenu
		: accountMenu.filter((item) => item.icon !== "heart-outline");
};

export const getVariantUrl = (
	staticProductUrl: string,
	product: FragmentOf<typeof CardProductFragment>,
	variant: FragmentOf<typeof CardProductVariantFragment>,
): string => {
	const productUrl = replaceParams(staticProductUrl, { slug: product.slug });
	return productUrl + (variant?.isMainVariant ? "" : `?sku=${variant.sku}`);
};
